export function downloadCSV(byteArrayStr: string, fileName: string) {
  var csvStr = atob(byteArrayStr);
  var blob = new Blob([csvStr], { type: "text/csv" });

  var hiddenElement = document.createElement("a");
  hiddenElement.href = window.URL.createObjectURL(blob);
  hiddenElement.target = "_blank";
  hiddenElement.download = `${fileName}`;
  hiddenElement.click();
}